<template>
    <div class="google-recaptcha"></div>
</template>

<script>
import {appHelper} from "../../utils/helpers/appHelper.js";

export default {
    name: "googleRecaptcha",
    emits: [
        'scriptLoaded'
    ],
    mounted() {
        this.loadRecaptchaScript();
    },
    beforeUnmount() {
        this.destroyRecaptchaScript();
    },
    methods : {
        loadRecaptchaScript() {
            const self = this;
            if (!document.getElementById('recaptcha-script')) {
                const script = document.createElement('script');
                script.src = 'https://www.google.com/recaptcha/api.js?render=' + appHelper.signIn.google.recaptcha;
                script.id = 'recaptcha-script';
                script.onload = () => {
                    self.initializeRecaptcha(self.$el);
                };
                document.head.appendChild(script);
            } else {
                self.initializeRecaptcha(self.$el);
            }
        },
        initializeRecaptcha(recaptchaElement) {
            grecaptcha.ready(() => {
                grecaptcha.render(recaptchaElement, {
                    sitekey: appHelper.signIn.google.recaptcha,
                    // Optional parameters
                    size: 'invisible', // Adjust according to your design
                    // other parameters as needed
                });
                this.$emit('scriptLoaded');
            });
        },
        destroyRecaptchaScript() {
            const badge = document.querySelector('.grecaptcha-badge[data-style="bottomright"]');
            const script = document.getElementById('recaptcha-script');

            if(badge) {
                badge.parentElement.remove();
            }

            if (script) {
                script.remove();
            }
        },
        verify() {
            return new Promise((resolve, reject) => {
                if (typeof grecaptcha !== 'undefined') {
                    grecaptcha.execute(appHelper.signIn.google.recaptcha, { action: 'submit' })
                        .then(token => {
                            // Handle the verified token here
                            resolve(token); // Resolve the Promise with the token
                        })
                        .catch(error => {
                            // Handle errors, if any
                            reject(error); // Reject the Promise with the error
                        });
                } else {
                    const error = new Error('reCAPTCHA script not loaded');
                    reject(error); // Reject the Promise with the error
                }
            });
        }
    }
}
</script>

<style scoped>

</style>
